import { render, staticRenderFns } from "./empleado.vue?vue&type=template&id=5bdcd44a&scoped=true&"
import script from "./empleado.vue?vue&type=script&lang=js&"
export * from "./empleado.vue?vue&type=script&lang=js&"
import style0 from "./empleado.vue?vue&type=style&index=0&id=5bdcd44a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdcd44a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/andres/repositories/merge/webapp/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListGroup } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileAction } from 'vuetify/lib'
import { VListTileContent } from 'vuetify/lib'
import { VListTileTitle } from 'vuetify/lib'
installComponents(component, {VDivider,VIcon,VList,VListGroup,VListTile,VListTileAction,VListTileContent,VListTileTitle})
